// Confirm deleting one road-network element (Safety Overview). The element leaves the
// road network of its state for everyone — map, Road features filter, passing-zone rules,
// crash correlation, verdicts, PDF — until it is restored from "Road network sources".
// The source data itself (MassDOT, OpenStreetMap, our sign runs) is not changed.
import React, { useState } from 'react';
import { Modal } from '../Overview/OverviewDialogs';
import { GUARDRAIL_LABEL, NET_CONDITIONS, NET_SOURCES } from './rules';

const TYPE_LABEL = { ...Object.fromEntries(NET_CONDITIONS.map(([k, label]) => [k, label])), guardrail: GUARDRAIL_LABEL };
const SOURCE_NAME = Object.fromEntries(NET_SOURCES.map(([k, label]) => [k, label]));

export default function RoadElementDeleteDialog({ feature, onConfirm, onClose }) {
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const confirm = async () => {
    setBusy(true);
    setError('');
    try {
      await onConfirm(reason.trim());
      onClose();
    } catch (e) {
      setError(e.message);
      setBusy(false);
    }
  };
  return (
    <Modal title="Delete a road element" onClose={busy ? () => {} : onClose}>
      <p className="safety-modal-lede">
        Delete this <b>{TYPE_LABEL[feature.type] || feature.type}</b> from the road network of the state?
      </p>
      <table className="ov-crit so-delete-facts">
        <tbody>
          <tr><td>What</td><td>{feature.label}</td></tr>
          <tr><td>Where</td><td>{feature.segName} · MP {Number(feature.mp).toFixed(2)}{feature.mpEnd != null ? `–${Number(feature.mpEnd).toFixed(2)}` : ''}</td></tr>
          <tr><td>Taken from</td><td>{SOURCE_NAME[feature.src] || feature.src}{feature.srcLabel ? ` · ${feature.srcLabel}` : ''}{feature.ref ? ` · ${feature.ref}` : ''}</td></tr>
        </tbody>
      </table>
      <p className="safety-muted">
        It disappears for everyone: from the map and the Road features filter, and from the passing-zone rules, so the
        deficiencies, the crash correlation, the verdicts and the PDF are recalculated without it. The source data is not
        changed. You can restore it under &quot;Road network sources&quot;.
      </p>
      <label className="safety-filter so-delete-reason" htmlFor="so-del-reason"><span>Reason (optional)</span>
        <textarea id="so-del-reason" rows={2} maxLength={500} value={reason} placeholder="Not there on the imagery"
          onChange={(e) => setReason(e.target.value)} />
      </label>
      {error && <div className="safety-error">{error}</div>}
      <div className="safety-modal-foot">
        <span />
        <div className="row-actions">
          <button type="button" className="safety-btn safety-btn-ghost" disabled={busy} onClick={onClose}>Cancel</button>
          <button type="button" className="safety-btn so-danger" disabled={busy} onClick={confirm}>
            {busy ? 'Deleting…' : 'Delete element'}
          </button>
        </div>
      </div>
    </Modal>
  );
}
